import React from "react";

function ColoredLogo({ className = null, size = 60, color = "#ED4E39" }) {
  const width = `${size}px`;
  const height = `${size / 1.2245}px`;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 60 49"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ fill: color }}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-0.000002, 0.000001)" fill={color} fillRule="nonzero">
          <path d="M23.5359094,48.0427034 L55.5324572,48.0427034 C69.148934,14.4128104 47.0151263,0 32.1505001,0 L23.5359094,0 C14.460002,0 0,3.99076775 0,25.786547 C0,43.2230593 15.6906426,47.8891803 23.5359094,48.0427034 Z" />
        </g>
      </g>
    </svg>
  );
}

export default ColoredLogo;
